import React, { Component } from 'react'
import Helmet from 'react-helmet'

import SectionWhatWeDo from '@/section-what-we-do'
import SectionCoreOffering from '@/section-core-offering'
import SectionDigitalTools from '@/section-digital-tools'
import SectionApp from '@/section-app'
import SectionDigitalExperience from '@/section-digital-experience'
import SectionRevenue from '@/section-revenue'

import shareImg from './images/what_we_do.png'

class Homepage extends Component {
  render() {
    const { data } = this.props

    return (
      <div>
        <Helmet>
          <title>What we do</title>
          <meta property="og:title" content="What we do" />
          <meta property="og:description" content="We bring beauty pageants to the next level with cutting-edge digital tools" />
          <meta property="og:image" content={`https://nextmiss.com${shareImg}`} />
          <meta property="og:url" content="https://nextmiss.com/what_we_do/" />
          <meta property="og:image:alt" content="What we do - Next Miss" />
        </Helmet>

        <SectionWhatWeDo data={data} />
        <SectionCoreOffering data={data} gray />
        <SectionApp data={data}/>
        <SectionDigitalTools data={data} gray />
        <SectionDigitalExperience data={data} />
        <SectionRevenue data={data} gray isSimple />
      </div>
    )
  }
}

export default Homepage

export const query = graphql`
  query WhatWeDoQuery {
    whatWeDoMain: imageSharp(id: { regex: "/whatWeDoMain/" }) {
      sizes(maxWidth: 1467) {
        ...GatsbyImageSharpSizes
      }
    },
    coreOffering1: imageSharp(id: { regex: "/coreOffering1/" }) {
      sizes(maxWidth: 197) {
        ...GatsbyImageSharpSizes
      }
    },
    coreOffering2: imageSharp(id: { regex: "/coreOffering2/" }) {
      sizes(maxWidth: 197) {
        ...GatsbyImageSharpSizes
      }
    },
    digitalTools: imageSharp(id: { regex: "/digitalTools/" }) {
      sizes(maxWidth: 2433) {
        ...GatsbyImageSharpSizes
      }
    },
    nextMissApp1: imageSharp(id: { regex: "/nextMissApp1/" }) {
      sizes(maxWidth: 198) {
        ...GatsbyImageSharpSizes
      }
    },
    nextMissApp2: imageSharp(id: { regex: "/nextMissApp2/" }) {
      sizes(maxWidth: 198) {
        ...GatsbyImageSharpSizes
      }
    },
    nextMissApp3: imageSharp(id: { regex: "/nextMissApp3/" }) {
      sizes(maxWidth: 198) {
        ...GatsbyImageSharpSizes
      }
    },
    nextMissApp4: imageSharp(id: { regex: "/nextMissApp4/" }) {
      sizes(maxWidth: 198) {
        ...GatsbyImageSharpSizes
      }
    },
    digitalExperience: imageSharp(id: { regex: "/digitalExperience/" }) {
      sizes(maxWidth: 2067) {
        ...GatsbyImageSharpSizes
      }
    },
    revenueImg1: imageSharp(id: { regex: "/revenue1/" }) {
      sizes(maxWidth: 186) {
        ...GatsbyImageSharpSizes
      }
    },
    revenueImg2: imageSharp(id: { regex: "/revenue2/" }) {
      sizes(maxWidth: 186) {
        ...GatsbyImageSharpSizes
      }
    },
    revenueImg3: imageSharp(id: { regex: "/revenue3/" }) {
      sizes(maxWidth: 186) {
        ...GatsbyImageSharpSizes
      }
    },
    revenueImg4: imageSharp(id: { regex: "/revenue4/" }) {
      sizes(maxWidth: 186) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/what_we_do.js